module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step3_Image0.bfe91fce.jpg";